(function(){
  'use strict';

  function initHero(slider){
    if(!slider || slider.dataset.elInitialized==='true') return;
    slider.dataset.elInitialized='true';
    var slides=[].slice.call(slider.querySelectorAll('.el-top-slide'));
    var dots=[].slice.call(slider.querySelectorAll('.el-top-slider-dot'));
    var prev=slider.querySelector('.el-top-slider-arrow--prev');
    var next=slider.querySelector('.el-top-slider-arrow--next');
    var mobile=window.matchMedia('(max-width:768px)');
    var index=0,timer=0,touchX=0,touchY=0;
    var speed=parseInt(slider.getAttribute('data-autoplay')||'6000',10);

    function show(i){
      if(!slides.length)return;
      index=(i+slides.length)%slides.length;
      slides.forEach(function(s,n){s.classList.toggle('is-active',n===index);});
      dots.forEach(function(d,n){d.classList.toggle('is-active',n===index);});
      var plant=slides[index]&&slides[index].getAttribute('data-theme')==='plant';
      slider.classList.toggle('is-plant-theme',plant);
      slider.classList.toggle('is-solar-theme',!plant);
    }
    function stop(){if(timer){clearInterval(timer);timer=0;}}
    function start(){
      stop();
      if(slides.length<2 || mobile.matches || document.hidden || slider.getAttribute('data-autoplay-enabled')==='false')return;
      timer=window.setInterval(function(){show(index+1);},speed);
    }
    function manual(i){show(i);start();}
    if(prev)prev.addEventListener('click',function(){manual(index-1);});
    if(next)next.addEventListener('click',function(){manual(index+1);});
    dots.forEach(function(d,n){d.addEventListener('click',function(){manual(n);});});
    slider.addEventListener('mouseenter',stop);
    slider.addEventListener('mouseleave',start);
    slider.addEventListener('touchstart',function(e){if(e.changedTouches&&e.changedTouches.length){touchX=e.changedTouches[0].clientX;touchY=e.changedTouches[0].clientY;}},{passive:true});
    slider.addEventListener('touchend',function(e){
      if(!e.changedTouches||!e.changedTouches.length)return;
      var dx=touchX-e.changedTouches[0].clientX,dy=touchY-e.changedTouches[0].clientY;
      if(Math.abs(dx)>=50&&Math.abs(dx)>Math.abs(dy))manual(dx>0?index+1:index-1);
    },{passive:true});
    document.addEventListener('visibilitychange',function(){document.hidden?stop():start();});
    if(mobile.addEventListener)mobile.addEventListener('change',start); else if(mobile.addListener)mobile.addListener(start);
    slider._elShow=show;
    show(0);start();
  }

  function initReferenceStrip(strip){
    if(!strip || strip.dataset.elInitialized==='true')return;
    strip.dataset.elInitialized='true';
    if('IntersectionObserver' in window){
      var obs=new IntersectionObserver(function(entries){entries.forEach(function(entry){strip.classList.toggle('is-inview',entry.isIntersecting);});},{rootMargin:'200px 0px'});
      obs.observe(strip);
    }else strip.classList.add('is-inview');
  }

  function initCards(scope){
    (scope||document).querySelectorAll('.el-clickable-card').forEach(function(card){
      if(card.dataset.elCard==='true')return;
      card.dataset.elCard='true';
      if(!card.hasAttribute('role'))card.setAttribute('role','link');
      if(!card.hasAttribute('tabindex'))card.setAttribute('tabindex','0');
    });
  }

  function init(scope){
    (scope||document).querySelectorAll('.el-top-slider').forEach(initHero);
    (scope||document).querySelectorAll('.engel-ref-strip').forEach(initReferenceStrip);
    initCards(scope||document);
  }

  function cardFrom(target){return target.closest?target.closest('.el-clickable-card'):null;}
  function cardHref(card){
    if(!card)return '';
    var a=card.querySelector('a[href]');
    return card.getAttribute('data-href')||(a?a.getAttribute('href'):'');
  }

  document.addEventListener('click',function(e){
    if(e.target.closest('a,button,input,select,textarea,summary'))return;
    var card=cardFrom(e.target),href=cardHref(card);
    if(href&&href!=='#')window.location.href=href;
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ')return;
    if(e.target.closest('a,button,input,select,textarea,summary'))return;
    var card=cardFrom(e.target),href=cardHref(card);
    if(!card||!href||href==='#')return;
    e.preventDefault();window.location.href=href;
  });
  document.addEventListener('shopify:block:select',function(e){
    var slide=e.target.closest&&e.target.closest('.el-top-slide');
    if(!slide)return;
    var slider=slide.closest('.el-top-slider');
    if(!slider||!slider._elShow)return;
    var slides=[].slice.call(slider.querySelectorAll('.el-top-slide'));
    slider._elShow(slides.indexOf(slide));
  });
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);}); else init(document);
})();
